import { render, staticRenderFns } from "./message.vue?vue&type=template&id=e0b4f292&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=e0b4f292&prod&lang=scss&scoped=true"
import style1 from "./message.vue?vue&type=style&index=1&id=e0b4f292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b4f292",
  null
  
)

export default component.exports